import React, { Component } from 'react';
import { Panel, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

class CollapsablePanel extends Component {

	constructor(props) {
		super(props);
		this.state = { open: props.collapsed === undefined ? true : !props.collapsed };
	}

	toggle() {
		if (!this.state.open && this.props.onExpand) {
			this.props.onExpand();
		}
		this.setState({ open: !this.state.open });
	}

	renderHeaderInfo(title, icon) {
		if (icon && title) {
			return [<FontAwesomeIcon icon={icon} key='panel-icon' />, title];
		}

		if (icon) {
			return <FontAwesomeIcon icon={icon} key='panel-icon'/>;
		}

		if (title) {
			return title;
		}

		return null;
	}

	renderCollapseButton() {
		const collapseIcon = this.state.open ? faChevronUp : faChevronDown;
		return (
			<div className='panel-tools' key='panel-tools'>
				<Button bsStyle='link' onClick={() => this.toggle()}>
					<FontAwesomeIcon icon={collapseIcon} />
				</Button>
			</div>
		);
	}

	renderHeader(title, icon) {
		const headerInfo = this.renderHeaderInfo(title, icon);
		const collapseButton = this.renderCollapseButton();
		return [headerInfo, collapseButton];
	}

	render() {
		const { title, icon } = this.props;
		return (
			<Panel expanded={this.state.open} onToggle={() => { }}>
				<Panel.Heading>{this.renderHeader(title, icon)}</Panel.Heading>
				<Panel.Collapse>
					<Panel.Body>
						{this.props.children}
					</Panel.Body>
				</Panel.Collapse>
			</Panel>
		);
	}
}

export default CollapsablePanel;